/**
 * HOME BUILT LINE — the beat's ADAPTER (Kyle dictation, 2026-08-04; split into
 * two slides 2026-08-08).
 *
 * The mechanism is in eg-scroll-sweep.js and is shared with the Vanilla panel
 * (sections/eg-home-panel.liquid). This file is the whole of what is specific
 * to THIS beat.
 *
 * WHAT IT ASKS THE DRIVER FOR, and what it pointedly does not. It asks for
 * group numbering — two stanzas that hand over to each other, so each needs to
 * know which it is and how many there are — plus the host's scroll progress and
 * the one-shot arrival. section-eg-home-builtline.css turns the group numbers
 * into each slide's own slice of the scroll (fade in, sit, fade out).
 *
 * IT DOES NOT ASK FOR A RECOLOUR, and there is nothing to switch off: the
 * driver has no colour in it at all. The per-character split still happens
 * because the driver always splits, but no rule in this beat's stylesheet reads
 * --eg-hb-i or --eg-hb-n, so the characters are inert carriers. The index and
 * count are still named below because the driver writes them unconditionally
 * and an unnamed property would be written as `undefined`.
 *
 * THIS FILE REPLACED A BESPOKE ONE-SHOT OBSERVER (2026-08-08). While the beat
 * was a single line it needed nothing but "say when it arrived", and it had its
 * own eight-line IntersectionObserver. The moment it needed a second slide it
 * needed scroll progress as well — at which point the shared driver already did
 * both, correctly, including the `bottom: -100%` root margin that makes the
 * arrival fire when the section PINS rather than a viewport early.
 *
 * WHY THE NAMES ARE `--eg-hb-*` RATHER THAN GENERIC: dialling this beat must
 * never move the Vanilla panel, and vice versa. The driver is name-agnostic
 * precisely so both can keep their own namespace.
 *
 * MOTION PREFERENCE IS NOT CHECKED HERE, ON PURPOSE. Splitting text is not
 * motion and a progress number is just a number. The CSS gates every animated
 * declaration behind `@media (prefers-reduced-motion: no-preference)`, so that
 * media query is the single arbiter — including when the user flips the OS
 * setting mid-session.
 *
 * FAIL-VISIBLE. `data-eg-hb-ready` is the CSS's permission to hide anything at
 * all. If this file never loads, or throws, that attribute is never set, the
 * hiding rules never match, and both sentences render plainly visible one under
 * the other — which is also their base style and their reduced-motion state.
 */
(function () {
  if (!window.EgScrollSweep) return;

  window.EgScrollSweep.mount({
    /* THE TALL TRACK, not the sticky panel inside it — a sticky element's rect
       stops moving the instant it pins, which is when this needs to start
       counting. */
    host: '.eg-homebuiltline-host',
    group: '[data-eg-hb-stanza]',
    line: '[data-eg-hb-line]',

    /* Written per frame on the host; 0 the moment the section pins, 1 at the
       end of the track. */
    progress: '--eg-hb-p',

    /* Written once per character span / once per stanza, and read by nothing —
       see the note above. */
    index: '--eg-hb-i',
    count: '--eg-hb-n',

    /* This slide's position in the sequence, and how long the sequence is.
       These two ARE read: they are what cuts the runway in half. */
    groupIndex: '--eg-hb-g',
    groupCount: '--eg-hb-gn',

    ready: 'data-eg-hb-ready',
    arrived: 'data-eg-hb-arrived',

    /* The split wrapper and the characters are pure carriers and stay
       `display: inline` — see section-eg-home-builtline.css. */
    inkClass: 'eg-homebuiltline__ink',
    charClass: 'eg-homebuiltline__char',
  });
})();
